import { Component, OnInit } from '@angular/core';
import { DropdownHelperModel } from "../../../models/helpers/dropdown-helper.model";
import { Subject, takeUntil } from "rxjs";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { VenueService } from "../../../services/venues/venue.service";
import { MessageService } from "primeng/api";
import { AssignVenuesMenuModel } from "../../../models/menus/assign-venue-menu.model";
import { MenuService } from "../../../services/menus/menu.service";

@Component({
  selector: 'app-assign-menu-to-venues',
  templateUrl: './assign-menu-to-venues.component.html',
  styleUrls: ['./assign-menu-to-venues.component.scss']
})
export class AssignMenuToVenuesComponent implements OnInit {

  //#region Fields
  public listAllVenues: Array<DropdownHelperModel> = new Array<DropdownHelperModel>();
  public selectedVenues: Array<string> = new Array<string>();
  public menuId: string;
  public unsubscribe: Subject<void> = new Subject<void>();
  public assignVenuesModel: AssignVenuesMenuModel = new AssignVenuesMenuModel();
  public spinner: boolean = false;
  //#endregion

  //#region Constructor
  constructor(private config: DynamicDialogConfig,
              private ref: DynamicDialogRef,
              private venueService: VenueService,
              private menuService: MenuService,
              private messageService: MessageService) {
    if (this.config.data != undefined && this.config.data.id) {
      this.menuId = this.config.data.id;
    }
    if (this.config.data != undefined && this.config.data.venues) {
      this.selectedVenues = this.config.data.venues.map((x: {venueId: string}) => x.venueId);
    }
  }

  ngOnInit(): void {
    this.getAllVenues();
  }
  //#endregion

  //#region Public Methods
  assignVenues(menuId: string, venueIds: string[]) {
    this.assignVenuesModel.venueMenuId = menuId;
    this.assignVenuesModel.venueIds = venueIds;

    this.menuService.addMenuToVenues(this.assignVenuesModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  getAllVenues() {
    this.spinner = true;
    this.listAllVenues = new Array<DropdownHelperModel>();

    this.venueService.listallgmnvenuesforcombo()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.listAllVenues = response;
          this.spinner = false;
        },
        error: errorResponse => {
          this.messageService.add({severity: 'error', summary: "System error", life: 2000});
          this.spinner = false;
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
